import { IonButton, IonCol, IonGrid, IonIcon, IonLabel, IonRow, IonText } from "@ionic/react";
import React from "react";
import CustomRoutes from "../../customRoutes";
import Header from "../../utils/Header";
import PersonalDetails from "./PersonalDetails";
import Profile from "../Portal/profile";
import {
  BOOK_A_SERVICE,
  MY_BOOKINGS,
  INSTALL_APP_AND_GET_DISCOUNT,
  DOWNLOAD_OUR_APP,
  EMPTY_CART,
  BOOK_CAR_SERVICE,
  BEST_CAR_SERVICE,
  ABOUT_AUTOROX,
  ABOUT_TSERV,
  REWARDS_OR_OFFERS,
  MY_CART,
  CITY_4334,
} from "../../constants";

import "../../global.scss";
import { chevronBackOutline } from "ionicons/icons";
import AddVehicle from "./AddVehicle";
import { connect } from "react-redux";
import { logout } from "../../Store/Actions";

const OnBoardingIndex: React.FC = (props: any) => {
  const { path } = props.match;

  return (
    <IonGrid className="pd_0">
      <Header {...props} />
      <IonRow className="panel_layout pd_0">
        <IonCol className="left_panel" size="12" size-sm size-md="3">
          <div className="ser_body_div">
            <div className="ser_fir_child">
              <div className="services">
                <img className="carImg" src="/images/car.svg" alt="car" />
                <IonText className="booking_div">{BOOK_A_SERVICE}</IonText>
              </div>
              <div className="services">
                <img className="carImg" src="/images/calendar.svg" alt="calendar" />
                <IonText className="booking_div">{MY_BOOKINGS}</IonText>
              </div>
              <div className="services">
                <img className="carImg" src="/images/offer.svg" alt="offer" />
                <IonText className="booking_div">{REWARDS_OR_OFFERS}</IonText>
              </div>
              <div className="services">
                <img className="carImg" src="/images/about.svg" alt="about" />
                <IonText className="booking_div">{ABOUT_AUTOROX}</IonText>
              </div>
            </div>
            {/* Download App from stores */}
            {/* <div className="ser_sec_child">
              <div className="ion-text-center social-icons">
                <div className="app_layout">
                  <img
                    className="download_icon"
                    src="/images/download_app.svg"
                    alt="downloadIcon"
                  />
                </div>
                <div className="download_app">
                  <IonText>{DOWNLOAD_OUR_APP}</IonText>
                </div>
                <div className="social_icons">
                  <img
                    className="google_play"
                    src="/images/googlePlay.png"
                    alt="googlePlay"
                  />
                  <img
                    className="app_store"
                    src="/images/appStore.png"
                    alt="appStore"
                  />
                </div>
                <div className="insttal_app">
                  <IonText>{INSTALL_APP_AND_GET_DISCOUNT}</IonText>
                </div>
              </div>
            </div> */}
          </div>
        </IonCol>
        <CustomRoutes
          routes={[
            {
              path: `${path}/personal-details`,
              component: PersonalDetails,
            },
            {
              path: `${path}/add-vehicle`,
              component: AddVehicle,
            },
          ]}
          exact={{
            path: `${path}`,
            route: `${path}/personal-details`,
          }}
          // role={role}
        />
        <IonCol size="12" size-sm size-md="3" className="my_cart_div">
          <div
            className={props.cart_items.length ? "cart_header cart_border_bottom" : "cart_header"}
          >
            <div className="card_left_panel">
              <IonText className="my_cart">{MY_CART}</IonText>
            </div>
          </div>
          <div className="cartItem">
            <img className="cart_img" src="/images/empty-cart.svg" alt="cart" />
            <IonLabel className="cart-text" color="secondary">
              {EMPTY_CART}
            </IonLabel>
          </div>

          <div className="btn_parent_div bt_left_40">
            <IonButton
              // onClick={() => setScreenName("AddVehicle")}
              onClick={() => props.history.push("/portal/book_service")}
              color="primary"
              className="continue_btn child_btn"
              expand="block"
            >
              {BOOK_CAR_SERVICE}
            </IonButton>
          </div>
          <p className="service_text">{BEST_CAR_SERVICE}</p>
        </IonCol>
      </IonRow>
    </IonGrid>
  );
};

export default connect(
  ({ cart, notification, auth }: any) => ({
    ...cart,
    ...notification,
    ...auth,
  }),
  { logout },
)(OnBoardingIndex);
